import { TPaymentType } from "./../type/paymentPage/IPaymentPageData"
import DefaultCardLogo from "../images/creditCardLogos/card-blue.png"
import DankortLogo from "../images/creditCardLogos/dankort.svg"
import VisaLogo from "../images/creditCardLogos/visa.svg"
import MasterCardLogo from "../images/creditCardLogos/mastercard.svg"
import ForbrugsforeningenLogo from "../images/creditCardLogos/forbrugsforeningen.svg"
import MobilePayOnlineLogo from "../images/paymentTypeLogo/mobilepay-logo-text.svg"
import ViabillLogo from "../images/paymentTypeLogo/viabill-primary-logo.png"
import AnydayLogo from "../images/paymentTypeLogo/anyday-logo.svg"
import BancontactLogo from "../images/paymentTypeLogo/bancontact-logo.svg"
import IdealLogo from "../images/paymentTypeLogo/ideal-logo.svg"
import VippsLogo from "../images/paymentTypeLogo/vipps-logo-text.svg"
import SwishLogo from "../images/paymentTypeLogo/swish-logo.png"
import KlarnaLogo from "../images/paymentTypeLogo/klarna-payment-logo.svg"
import ApplePayLogo from "../components/applePay/assets/ApplePayLogoWithBorder.svg"
import ResursLogo from "../images/paymentTypeLogo/resurs-icon.webp"
import TermsTechLogo from "../images/paymentTypeLogo/termstech-logo.svg"

import { TCreditCardType } from "../type/paymentPage/IPaymentPageData"
import i18next from "i18next"

import { TImage } from "../locale/images/ITransalationImages"
import { daImages } from "../locale/images/imageDa"
import { enImages } from "../locale/images/imageEn"
import { getLanguage } from "./../locale/lang"

export function getImageByLanguage(image: TImage): string {
    const lang = getLanguage()
    switch (lang) {
        case "da":
            return daImages.images[image]
        case "en":
            return enImages.images[image]
        default:
            return daImages.images[image]
    }
}

export const getLogoByCardType = (type: TCreditCardType, onDefaultEmpty?: boolean) => {
    switch (type) {
        case "Visa":
            return VisaLogo
        case "MasterCard":
            return MasterCardLogo
        case "Dankort":
            return DankortLogo
        case "Forbrugsforeningen":
            return ForbrugsforeningenLogo
        default:
            return onDefaultEmpty ? "" : DefaultCardLogo
    }
}

export const getLogoByPaymentType = (type: TPaymentType) => {
    switch (type) {
        case "Swish":
            return SwishLogo
        case "MobilePayOnline":
            return MobilePayOnlineLogo
        case "Viabill":
            return ViabillLogo
        case "Anyday":
            return AnydayLogo
        case "Ideal":
            return IdealLogo
        case "Bancontact":
            return BancontactLogo
        case "AccountToAccount":
            return getImageByLanguage("bankLogos")
        case "CreditCard":
            return DefaultCardLogo
        case "Vipps":
            return VippsLogo
        case "KlarnaPayLater":
            return KlarnaLogo
        case "KlarnaFinancing":
            return KlarnaLogo
        case "ApplePay":
            return ApplePayLogo
        case "ResursInvoice":
            return ResursLogo
        case "ResursPartPayment":
            return ResursLogo
        case "ResursRevolvingCredit":
            return ResursLogo
        case "TermsTech":
            return TermsTechLogo
        default:
            return ""
    }
}

export const getDescriptionByPaymentType = (type: TPaymentType) => {
    switch (type) {
        case "CreditCard":
            return i18next.t("paymentpage.paymentTypes.cardpayment")
        case "MobilePayOnline":
            return i18next.t("paymentpage.paymentTypes.mobilepay")
        case "Viabill":
            return i18next.t("paymentpage.paymentTypes.viabill")
        case "Anyday":
            return i18next.t("paymentpage.paymentTypes.anyday")
        case "Bancontact":
            return i18next.t("paymentpage.paymentTypes.bancontact")
        case "Ideal":
            return i18next.t("paymentpage.paymentTypes.ideal")
        case "AccountToAccount":
            return i18next.t("paymentpage.paymentTypes.a2a")
        case "Swish":
            return i18next.t("paymentpage.paymentTypes.swish")
        case "Vipps":
            return i18next.t("paymentpage.paymentTypes.vipps")
        case "KlarnaPayLater":
            return i18next.t("paymentpage.paymentTypes.klarnapaylater")
        case "KlarnaFinancing":
            return i18next.t("paymentpage.paymentTypes.klarnafinancing")
        case "ApplePay":
            return i18next.t("paymentpage.paymentTypes.applepay")
        case "ResursInvoice":
            return i18next.t("paymentpage.paymentTypes.resursinvoice")
        case "ResursPartPayment":
            return i18next.t("paymentpage.paymentTypes.resurspartpayment")
        case "ResursRevolvingCredit":
            return i18next.t("paymentpage.paymentTypes.resursrevolvingcredit")
        case "TermsTech":
            return i18next.t("paymentpage.paymentTypes.termstech")
        default:
            return ""
    }
}
